// extracted by mini-css-extract-plugin
module.exports = {"thumb":"_1-7Uz","activeThumb":"_4tOVn","panel":"_3yqWl","shownPanel":"_1kbeV"};